import { createRouter, createWebHashHistory } from 'vue-router';
import Index from '../views/index.vue';
import Login from '../views/login.vue';
import * as constant from '@/router/constant';

const routes = [
  {
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
    redirect: '/index/situation',
    children: [
      {
        path: 'introduce',
        meta: {
          title: '园区介绍',
        },
        component: constant.Introduce,
      },
      {
        path: 'situation',
        meta: {
          title: '综合态势',
        },
        component: constant.Situation,
      },
      {
        path: 'safe',
        meta: {
          title: '安全态势',
        },
        component: constant.Safe,
      },
      {
        path: 'industry',
        meta: {
          title: '产业优势',
        },
        component: constant.Industry,
      },
      {
        path: 'operation',
        meta: {
          title: '运营态势',
        },
        component: constant.Operation,
      },
      {
        path: 'om',
        meta: {
          title: '运维态势',
        },
        component: constant.OM,
      },
      {
        path: 'workshop',
        meta: {
          title: '车间',
        },
        component: constant.Introduce,
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
